import Crud from '../components/Rooms/Crud'
import Entity from '../components/Rooms/Add'
import View from '../components/Rooms/View'
import Lock from '../components/Rooms/Lock'

let routes = {
    path: '/rooms',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/rooms/add',
            name: 'Nova Sala',
            component: Entity
        },
        {
            path: '/rooms/edit/:id?',
            name: 'Editar Sala',
            component: Entity
        },
        {
            path: '/rooms/lock/:id?',
            name: 'Bloqueios da Sala',
            component: Lock
        },
        {
            path: '/rooms/view/:id?',
            name: 'Visualizar Sala',
            component: View
        },
        {
            path: '/rooms',
            name: 'Salas',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/rooms.js